export default __webpack_public_path__ + "static/media/offer_type_1.129241d7.png";